import { Box } from '@mui/material';
import { LayoutType } from 'model/deals.model';
import { SyntheticEvent, useEffect, useState } from 'react';
import { ViewTypeEnum } from 'service/businesses.service';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { fetchBusinesses } from 'store/slices/businessesSlice';
import AdminSearch from './AdminSearch';
import { Filters } from './Filters';
import Grid from './Grid';
import TableView from './Table';

const BusinessesMain = () => {
  const dispatch = useAppDispatch();
  const { tabValue, pagination, categories, categoryValue, searchTerm, sortBy, sortOrder } =
    useAppSelector((state) => state.businesses);

  const businessesViewType =
    (sessionStorage.getItem('businessesViewType') as LayoutType) || LayoutType.KANBAN;
  const [layout, setLayout] = useState<LayoutType>(businessesViewType);

  const handleLayoutChange = (_: SyntheticEvent, newValue: LayoutType) => {
    sessionStorage.setItem('businessesViewType', newValue);
    setLayout(newValue);
  };

  const VIEW_MAP = [ViewTypeEnum.mine, ViewTypeEnum.all] as const;

  useEffect(() => {
    const categoryName = categories?.[categoryValue]?.name;
    dispatch(
      fetchBusinesses({
        view: VIEW_MAP[tabValue] || ViewTypeEnum.mine,
        page: pagination.page,
        pageSize: pagination.pageSize,
        search: searchTerm,
        category: categoryName,
        sortBy,
        sortOrder,
      }),
    );
  }, [
    tabValue,
    dispatch,
    pagination.page,
    pagination.pageSize,
    searchTerm,
    categoryValue,
    sortBy,
    sortOrder,
  ]);

  const content = layout === LayoutType.KANBAN ? <Grid /> : <TableView />;

  return (
    <Box
      sx={{
        padding: '24px',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Filters layout={layout} onLayoutChange={handleLayoutChange} />
      {content}
      <AdminSearch />
    </Box>
  );
};

export default BusinessesMain;
